import './styles/App.css';

import './styles/onqor.scss'

import React, {Component} from 'react';
import MainForm from "./components/main_form";
import Header from "./components/header";

class App extends Component {
	render() {
		return (
			<div className="platformMatch-tool">
				<Header/>
					<h3 className="title-text text-center">Event platforms matched for you</h3>
					<p className="title-p">
					  Save yourself the time and hassle of researching multiple event platforms with our Platform Match tool.
          </p>
					<p className="title-p">
					  Platform Match scans the market of industry-leading event platforms to match their features to your specific event requirements.
          </p>
          <p className="title-p">
            After a few clicks, the top 3 suited event platforms will be sent to you to explore.
          </p>
          <p className="title-p">
            It saves you time, stress, and money and delivers a solution straight to your inbox.
          </p>
					<p className="title-p">Your perfect platform is just a few clicks away.</p>
					<h2 className="title-text-box text-center">What are you planning?</h2>
					<MainForm />
			</div>
		);
	}
}

export default App;
